export default {
    shortDate: function(date) {
    return date;
  },
}